import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition, TicketViewModel, TicketStatusId } from '../../../../models';
import { DoughnutChartOptions } from '../../../../framework/charting/charts/DoughnutChart/DoughnutChart.options';
import { SeriesFormat } from '../../../../framework/charting/charts/DoughnutChart/DoughnutChart.series';
import { Helper } from '../../../../common';


class TicketsDoughnutController implements angular.IComponentController {
    data: any[];
    isLoading: boolean;
    loadingMessage: string;
    options: DoughnutChartOptions;
    series: SeriesFormat[];
    tickets: TicketViewModel[];

    static $inject = [];

    $onInit() {
        this.series = this.series || [];
        this.data = this.data || [];
        this.options = {
            isLabelsVisible: true,
            isLegendVisible: true,
            isTitleVisible: false,
            thickness: 20,
            title: '',
            dataFormat: {
                identifier: d => d.userName,
                label: d => d.userName,
                value: d => d.value
            }
        };
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['tickets'] && this.tickets) {
            const openTickets = this.tickets.filter(t => t.model.statusId !== TicketStatusId.Closed);
            const nested = d3.nest<TicketViewModel>()
                .key(d => d.assignedUser.displayName)
                .entries(openTickets)
                .map(d => {
                    return {
                        userName: d.key,
                        value: d.values.length
                    };
                })
                .sort((a, b) => a.value > b.value ? -1 : 1);
            this.series = nested.map((d, i) => {
                return {
                    userName: d.userName,
                    color: Helper.getColor(i),
                    format: d => d3.format('.')(d)
                };
            });
            this.data = nested;
        }
    }
}

export const wtTicketsDoughnut: ComponentDefinition = {
    componentId: 'wtTicketsDoughnut',
    controller: TicketsDoughnutController,
    template: require('./ticketsDoughnut.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        tickets: '<'
    }
};
